import React from 'react';
import { observer } from 'mobx-react';
import { GridMultilineCellTemplate } from 'themes/components';

@observer
class GridMultilineCell extends React.Component {
    render() {
        return (
            <GridMultilineCellTemplate {...this.props}/>
        );
    }
}

export default GridMultilineCell;